import React from 'react';
import Linkify from 'react-linkify';

const changeDecorator = (decoratedHref, decoratedText, key) => (
  <a target="blank" href={decoratedHref} key={key}>
    {decoratedText}
  </a>
);

export default function FormatText(props) {
  return (
    <Linkify
      componentDecorator={changeDecorator}
    >
      <p className="display-linebreak">{props.text}</p>
    </Linkify>
  );
}
